query getSwapTransactions($type: String, $limit: Int, $offset: Int) {
  getSwapTransactions(type: $type, limit: $limit, offset: $offset)
}
